import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step5 } from '../../../../shared/models/component-messages/simp_in/step5';
import { Oui_TypeOuiNonInformComplementaire } from '../models/Oui_TypeOuiNonInformComplementaire';
@Component({
	selector: 'app-oui-type-oui-non-inform-complementaire',
	templateUrl: './oui-type-oui-non-inform-complementaire.component.html'
})
export class OuiTypeOuiNonInformComplementaireComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'Oui_TypeOuiNonInformComplementaire';
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() oui: Oui_TypeOuiNonInformComplementaire;

	public step5 = new Step5();

	constructor() {}

	public ngOnInit() {}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
